
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("6vx1i", function(module, exports) {
/* ReadingAidsAcronymsHighlighter.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $3IBnw = parcelRequire("3IBnw");


var $aJv6Q = parcelRequire("aJv6Q");


var $jmjWc = parcelRequire("jmjWc");


var $bjVRl = parcelRequire("bjVRl");

const $7618df873c80ee96$var$readingAidsPopupPortalContainerId = 'reading-aids-portal-container';

const $7618df873c80ee96$var$ReadingAidsSpotlightWrapper = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "7h_DJ",
    name: "ReadingAidsSpotlightWrapper",
    loader: async ()=>(await (parcelRequire("lhrLa"))).ReadingAidsSpotlightWrapper
});

const $7618df873c80ee96$var$ReadingAidsPopup = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "fofjy",
    name: "ReadingAidsPopup",
    loader: async ()=>(await (parcelRequire("c25Lb"))).ReadingAidsPopup
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $7618df873c80ee96$var$Container = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_1reoewfl _18m9ewfl _kqswh2mm _1pby1o8a",
            __cmplp.className
        ])
    });
});
const $7618df873c80ee96$var$ReadingAidsAcronymsHighlighterComponent = ({ contentId: contentId })=>{
    const { showPopup: showPopup, autohighlightContext: autohighlightContext, autohighlightSelectionRect: autohighlightSelectionRect, autohighlightText: autohighlightText, sessionId: sessionId, showSpotlight: showSpotlight } = (0, $bjVRl.useReadingAidsState)();
    const portalContainerRef = (0, $42omo.useRef)(null);
    const { hideAutohighlightPopup: hideAutohighlightPopup, setPortalContainerRef: setPortalContainerRef } = (0, $bjVRl.useReadingAidsActions)();
    const selectionRect = {
        top: autohighlightSelectionRect.top,
        left: autohighlightSelectionRect.left,
        width: autohighlightSelectionRect.width,
        height: autohighlightSelectionRect.height
    };
    (0, $42omo.useEffect)(()=>{
        setPortalContainerRef({
            portalContainerRef: portalContainerRef
        });
    }, [
        portalContainerRef,
        setPortalContainerRef
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($7618df873c80ee96$var$Container, {
        id: $7618df873c80ee96$var$readingAidsPopupPortalContainerId,
        ref: portalContainerRef
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($7618df873c80ee96$var$ReadingAidsSpotlightWrapper, {
        contentId: contentId,
        selectionRect: selectionRect,
        showSpotlight: showSpotlight
    }), showPopup && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($7618df873c80ee96$var$ReadingAidsPopup, {
        selectedText: autohighlightText,
        additionalContext: autohighlightContext,
        selectionRect: selectionRect,
        isReadingAidsOpen: showPopup,
        onResult: ()=>{},
        onClose: hideAutohighlightPopup,
        contentId: contentId,
        popupPortalContainerId: $7618df873c80ee96$var$readingAidsPopupPortalContainerId,
        isAutohighlighted: true,
        sessionId: sessionId
    }));
};
const $7618df873c80ee96$export$ffdc57aecb97ae41 = (0, $aJv6Q.withErrorBoundary)({
    attribution: (0, $3IBnw.Attribution).KNOWLEDGE_DISCOVERY
})($7618df873c80ee96$var$ReadingAidsAcronymsHighlighterComponent);
module.exports["ReadingAidsAcronymsHighlighter"] = $7618df873c80ee96$export$ffdc57aecb97ae41;

});

parcelRegister("lhrLa", function(module, exports) {

let $f7e0b7fe1134fa59$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $f7e0b7fe1134fa59$var$load("fdsim").then(()=>parcelRequire('jgOPc'));

});

parcelRegister("c25Lb", function(module, exports) {

let $8c2a23c4ff85dad1$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $8c2a23c4ff85dad1$var$load("h3ABO"),
    $8c2a23c4ff85dad1$var$load("9hYRW"),
    $8c2a23c4ff85dad1$var$load("kpm7S"),
    $8c2a23c4ff85dad1$var$load("5wC2D"),
    $8c2a23c4ff85dad1$var$load("2YffH"),
    $8c2a23c4ff85dad1$var$load("g7ggm"),
    $8c2a23c4ff85dad1$var$load("eEyVs"),
    $8c2a23c4ff85dad1$var$load("6mHrv"),
    $8c2a23c4ff85dad1$var$load("awWN9"),
    $8c2a23c4ff85dad1$var$load("9CYct"),
    $8c2a23c4ff85dad1$var$load("iabAo"),
    $8c2a23c4ff85dad1$var$load("gFmis"),
    $8c2a23c4ff85dad1$var$load("hZtKG"),
    $8c2a23c4ff85dad1$var$load("dkqvW"),
    $8c2a23c4ff85dad1$var$load("lVO3w"),
    $8c2a23c4ff85dad1$var$load("hyzoX"),
    $8c2a23c4ff85dad1$var$load("h9Ed7"),
    $8c2a23c4ff85dad1$var$load("eBRUf"),
    $8c2a23c4ff85dad1$var$load("kbRvk"),
    $8c2a23c4ff85dad1$var$load("tKhaz"),
    $8c2a23c4ff85dad1$var$load("cD6Zr"),
    $8c2a23c4ff85dad1$var$load("k3jER"),
    $8c2a23c4ff85dad1$var$load("9wzNh"),
    $8c2a23c4ff85dad1$var$load("8YSo7"),
    $8c2a23c4ff85dad1$var$load("hwT9D"),
    $8c2a23c4ff85dad1$var$load("j4Bpe"),
    $8c2a23c4ff85dad1$var$load("9ldRJ"),
    $8c2a23c4ff85dad1$var$load("50ame"),
    $8c2a23c4ff85dad1$var$load("7do1E"),
    $8c2a23c4ff85dad1$var$load("77dkW"),
    $8c2a23c4ff85dad1$var$load("1MlIV"),
    $8c2a23c4ff85dad1$var$load("6iz6l"),
    $8c2a23c4ff85dad1$var$load("4SCW2"),
    $8c2a23c4ff85dad1$var$load("eukPA"),
    $8c2a23c4ff85dad1$var$load("9QSJH"),
    $8c2a23c4ff85dad1$var$load("Wowvf"),
    $8c2a23c4ff85dad1$var$load("421lv"),
    $8c2a23c4ff85dad1$var$load("dek7I"),
    $8c2a23c4ff85dad1$var$load("3SmkN"),
    $8c2a23c4ff85dad1$var$load("dYtBN"),
    $8c2a23c4ff85dad1$var$load("kNV5Y"),
    $8c2a23c4ff85dad1$var$load("6wr18"),
    $8c2a23c4ff85dad1$var$load("kjZZD"),
    $8c2a23c4ff85dad1$var$load("99Ppz"),
    $8c2a23c4ff85dad1$var$load("5v2fx"),
    $8c2a23c4ff85dad1$var$load("fkb26"),
    $8c2a23c4ff85dad1$var$load("37ldp"),
    $8c2a23c4ff85dad1$var$load("ffEVr"),
    $8c2a23c4ff85dad1$var$load("9AXkC"),
    $8c2a23c4ff85dad1$var$load("28arV"),
    $8c2a23c4ff85dad1$var$load("hhss7"),
    $8c2a23c4ff85dad1$var$load("lkwGP"),
    $8c2a23c4ff85dad1$var$load("fGPXi"),
    $8c2a23c4ff85dad1$var$load("dP7ao"),
    $8c2a23c4ff85dad1$var$load("hogcU"),
    $8c2a23c4ff85dad1$var$load("dkgtP"),
    $8c2a23c4ff85dad1$var$load("g43Ev"),
    $8c2a23c4ff85dad1$var$load("7EorR"),
    $8c2a23c4ff85dad1$var$load("avRkh")
]).then(()=>parcelRequire('cmXz4'));

});


//# sourceMappingURL=ReadingAidsAcronymsHighlighter.a597c665.js.map
